import { useState } from "react";
// eslint-disable-next-line
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Footer from "../components/Footer.jsx";

import {
  Stack,
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";

export default function Main({ first_login }) {
  const sx = {
    wrapper: { width: 1, alignItems: "center", pt: 15 },
    container: { width: 1, alignItems: "center" },
  };

  return (
    <Stack sx={sx.wrapper}>
      <Appbar first_login={first_login} />
      <Stack sx={sx.container} spacing={5}>
        <Hero />

        <Divider flexItem />
        <Features />

        <Divider flexItem />
        <Pricing />

        <Divider flexItem />
        <Faqs />

        <Divider flexItem />
      </Stack>
      <Footer />
    </Stack>
  );
}

function Appbar({ first_login }) {
  const sx = {
    wrapper: {
      width: "calc(95% - 30px)",
      height: 50,
      border: 1,
      px: "15px",
      justifyContent: "space-between",
      alignItems: "center",
      position: "fixed",
      top: 30,
      backdropFilter: "blur(24px)",
    },
    btn: {
      p: 1,
      borderRadius: "10px",
      cursor: "pointer",
      "&:hover": { backgroundColor: "lightgrey" },
    },
  };
  return (
    <Stack direction="row" sx={sx.wrapper}>
      <Stack direction="row" spacing={1}>
        <Typography sx={sx.btn}>Cybersecurity</Typography>
        <Typography
          sx={sx.btn}
          onClick={() => {
            axios({
              url: `${process.env.REACT_APP_BE_URL}/download`,
              method: "get",
              responseType: "blob", // important
            })
              .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement("a");
                link.href = href;
                link.setAttribute("download", "file.txt"); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
              })
              .catch((error) => console.log(error));
          }}
        >
          Features
        </Typography>
        <Typography sx={sx.btn}>Pricing</Typography>
        <Typography sx={sx.btn}>Faq</Typography>
      </Stack>

      <Stack direction="row" spacing={1}>
        <Typography sx={sx.btn} onClick={first_login}>
          Sign in
        </Typography>
        <Typography sx={sx.btn}>Talk to sales</Typography>
      </Stack>
    </Stack>
  );
}

function Hero() {
  const sx = {
    title: { fontSize: 50 },
    banner: { width: 1000, height: 400, border: 1 },
    description: { width: 600 },
  };
  return (
    <>
      <Typography sx={sx.title} align="center">
        Cybersecurity
      </Typography>
      <Stack sx={sx.banner} />
      <Typography sx={sx.description} align="center">
        Cybersecurity Cybersecurity Cybersecurity Cybersecurity Cybersecurity
      </Typography>
    </>
  );
}

function Features() {
  const sx = {
    row: { width: 1000 },
    title: {},
    pic: { width: 500, border: 1, height: 300, borderRadius: 0 },
    desc: {
      width: 500,
      border: 1,
      height: 300,
      borderRadius: 5,
      alignItems: "center",
      justifyContent: "center",
    },
  };

  return (
    <>
      <Typography sx={sx.title}>Features</Typography>
      <Stack sx={sx.row} direction="row" spacing={2}>
        <Stack sx={sx.pic}></Stack>
        <Stack sx={sx.desc}>
          <Typography align="center">- Feature 1</Typography>
          <Typography>- Feature 2</Typography>
          <Typography>- Feature 3</Typography>
        </Stack>
      </Stack>
    </>
  );
}

function Pricing() {
  const sx = {
    row: { width: 1000 },
    title: {},
    card: {
      width: 1 / 3,
      border: 1,
      height: 300,
      borderRadius: 5,
      alignItems: "center",
      justifyContent: "center",
    },
  };

  return (
    <>
      <Typography sx={sx.title}>Pricing</Typography>
      <Stack sx={sx.row} direction="row" spacing={2}>
        <Stack sx={sx.card}>
          <Typography align="center">Free Member</Typography>
          <Typography align="center">- Something 1.</Typography>
          <Typography align="center">- Something 2.</Typography>
          <Typography align="center">- Something 3.</Typography>
        </Stack>

        <Stack sx={sx.card}>
          <Typography align="center">Standard Member</Typography>
          <Typography align="center">- Something 1.</Typography>
          <Typography align="center">- Something 2.</Typography>
          <Typography align="center">- Something 3.</Typography>
        </Stack>

        <Stack sx={sx.card}>
          <Typography align="center">Business Member</Typography>
          <Typography align="center">- Something 1.</Typography>
          <Typography align="center">- Something 2.</Typography>
          <Typography align="center">- Something 3.</Typography>
        </Stack>
      </Stack>
    </>
  );
}

function Faqs() {
  const faqs = [
    { q: "Hello?", a: "Hi." },
    { q: "What?", a: "Something." },
    { q: "Who", a: "Someone." },
  ];

  const [expanded, set_expanded] = useState();
  const sx = {
    container: { width: 1000 },
  };

  return (
    <>
      <Typography>Frequently asked questions</Typography>
      <Stack sx={sx.container}>
        {faqs.map((e, i) => (
          <Accordion
            key={i}
            expanded={expanded === i}
            onChange={() => set_expanded(i)}
          >
            <AccordionSummary>
              <Typography>{e.q}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{e.a}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Stack>
    </>
  );
}
